import styles from './styles.module.scss';
import moment from 'moment';
import { useState, useEffect } from 'react';

interface DayPickerProps {
  value?: string; // YYYY-MM-DD
  onChange: (dateString: string) => void; // YYYY-MM-DD
  disabled?: boolean;
}

export const DaySlider = ({ value, onChange, disabled = false }: DayPickerProps) => {
  const [currentDate, setCurrentDate] = useState<moment.Moment>(
    value ? moment(value, 'YYYY-MM-DD') : moment().startOf('day')
  );

  useEffect(() => {
    if (value) {
      setCurrentDate(moment(value, 'YYYY-MM-DD'));
    }
  }, [value]);

  const handlePrevDay = () => {
    if (disabled) return;
    const newDate = currentDate.clone().subtract(1, 'day');
    setCurrentDate(newDate);
    onChange(newDate.format('YYYY-MM-DD'));
  };

  const handleNextDay = () => {
    if (disabled) return;
    const newDate = currentDate.clone().add(1, 'day');
    setCurrentDate(newDate);
    onChange(newDate.format('YYYY-MM-DD'));
  };

  return (
    <div className="d-flex align-items-center">
      <svg
        width="30"
        height="30"
        onClick={handlePrevDay}
        className="cursor-pointer"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" rx="8" fill="#EEF6FF" />
        <path
          d="M14.0984 14.9992L17.9984 18.8992C18.1818 19.0826 18.2734 19.3159 18.2734 19.5992C18.2734 19.8826 18.1818 20.1159 17.9984 20.2992C17.8151 20.4826 17.5818 20.5742 17.2984 20.5742C17.0151 20.5742 16.7818 20.4826 16.5984 20.2992L11.9984 15.6992C11.8984 15.5992 11.8276 15.4909 11.7859 15.3742C11.7443 15.2576 11.7234 15.1326 11.7234 14.9992C11.7234 14.8659 11.7443 14.7409 11.7859 14.6242C11.8276 14.5076 11.8984 14.3992 11.9984 14.2992L16.5984 9.69922C16.7818 9.51589 17.0151 9.42422 17.2984 9.42422C17.5818 9.42422 17.8151 9.51589 17.9984 9.69922C18.1818 9.88255 18.2734 10.1159 18.2734 10.3992C18.2734 10.6826 18.1818 10.9159 17.9984 11.0992L14.0984 14.9992Z"
          fill="#3B74CE"
        />
      </svg>

      <div className={styles.dateFilter}>{currentDate.format('dddd DD MMM YYYY')}</div>

      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        onClick={handleNextDay}
        className="cursor-pointer"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="30" y="30" width="30" height="30" rx="8" transform="rotate(-180 30 30)" fill="#EEF6FF" />
        <path
          d="M15.9016 15.0008L12.0016 11.1008C11.8182 10.9174 11.7266 10.6841 11.7266 10.4008C11.7266 10.1174 11.8182 9.88411 12.0016 9.70078C12.1849 9.51745 12.4182 9.42578 12.7016 9.42578C12.9849 9.42578 13.2182 9.51745 13.4016 9.70078L18.0016 14.3008C18.1016 14.4008 18.1724 14.5091 18.2141 14.6258C18.2557 14.7424 18.2766 14.8674 18.2766 15.0008C18.2766 15.1341 18.2557 15.2591 18.2141 15.3758C18.1724 15.4924 18.1016 15.6008 18.0016 15.7008L13.4016 20.3008C13.2182 20.4841 12.9849 20.5758 12.7016 20.5758C12.4182 20.5758 12.1849 20.4841 12.0016 20.3008C11.8182 20.1174 11.7266 19.8841 11.7266 19.6008C11.7266 19.3174 11.8182 19.0841 12.0016 18.9008L15.9016 15.0008Z"
          fill="#3B74CE"
        />
      </svg>
    </div>
  );
};
